import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from '@/components/shadcn-ui/sonner';

function App() {
  return (
    <div className="App app-class">
      <Navbar />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      <Toaster />
    </div>
  );
}

export default App;
